import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import classes from "./popover.module.scss";
import { useOnClickOutside } from "hooks/ClickOutside";

type PopoverDirection = "left" | "right" | "top" | "bottom";

interface IPopoverProps {
  isOpen: boolean;
  direction?: PopoverDirection;
  title?: string;
  onClose: Function;
  arrowStyle?: React.CSSProperties;
  position: {
    top?: number;
    left?: number;
    offsetTop?: number;
    offsetLeft?: number;
    offsetByWindowSizeX?: boolean;
    offsetByWindowSizeY?: boolean;
  };
  children: React.ReactNode;
}

const modalElement = document.getElementById("popover-root");

const Popover = ({
  position: { top = 0, left = 0, offsetTop = 0, offsetLeft = 0, offsetByWindowSizeX = false, offsetByWindowSizeY = false },
  isOpen = true,
  title = undefined,
  direction = "top",
  arrowStyle,
  onClose,
  children,
}: IPopoverProps) => {
  const [windowSizeX, setWindowSizeX] = useState(document.body.offsetWidth);
  const [windowSizeY, setWindowSizeY] = useState(document.body.offsetHeight);

  const ref = useRef<HTMLDivElement>(null);

  const getDirectionClass = (direction: PopoverDirection) => {
    switch (direction) {
      case "left":
        return classes.left;
      case "right":
        return classes.right;
      case "bottom":
        return classes.bottom;
      case "top":
        return classes.top;
    }
  };

  useOnClickOutside(ref, onClose);

  useEffect(() => {
    function handleResize() {
      setWindowSizeX(document.body.offsetWidth);
      setWindowSizeY(document.body.offsetHeight);
    }

    // Attach the event listener to the window object
    window.addEventListener('resize', handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  if (modalElement != null) {
    return createPortal(
      isOpen ? (
        <div
          ref={ref}
          className={`${classes.popover} ${getDirectionClass(direction)}`}
          style={{
            top: top + offsetTop + (offsetByWindowSizeY ? windowSizeY : 0),
            left: left + offsetLeft + (offsetByWindowSizeX ? windowSizeX : 0)
          }}
        >
          {title && <div className={classes.popoverHeader}>{title}</div>}
          <div className={classes.arrow} style={arrowStyle} />
          <div className={classes.popoverContent}>{children}</div>
        </div>
      ) : null,
      modalElement
    );
  } else {
    console.error("Popover root element should be defined in HTML template!");
    return null;
  }
};

export default Popover;
